/**
 * Optimized Interview Management Header Component
 * Separated for better maintainability and performance
 */

import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import Icon from '../AppIcon';

const InterviewManagementHeader = memo(({
  calendarView,
  onCalendarToggle,
  onScheduleInterview,
  onOpenTimeSlotManager
}) => {
  const navigate = useNavigate();

  return (
    <div className="w-full mb-4 col-span-full px-4">
      <div className="flex items-center space-x-4 mb-4">
        <button
          onClick={() => navigate('/employer-dashboard')}
          className="p-2 rounded-lg border border-border hover:border-primary hover:bg-primary-50 transition-colors duration-200"
          aria-label="Back to dashboard"
        >
          <Icon name="ArrowLeft" size={20} />
        </button>
        <div>
          <h1 className="text-2xl lg:text-3xl font-bold text-text-primary">
            Interview Management
          </h1>
          <p className="text-text-secondary mt-1">
            Schedule, manage, and track all your candidate interviews
          </p>
        </div>
      </div>
      
      <div className="flex flex-wrap gap-2 justify-between items-center">
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onOpenTimeSlotManager}
            className="flex items-center gap-2"
            title="Manage your available time slots for interviews"
          >
            <Icon name="Clock" size={16} />
            <span className="hidden sm:inline">Time Slots</span>
          </Button>
        </div>
        
        {/* Calendar Toggle */}
        <div className="flex items-center gap-2">
          <Button
            variant={calendarView ? "primary" : "outline"}
            size="sm"
            onClick={onCalendarToggle}
            className="flex items-center gap-2"
          >
            <Icon name="Calendar" size={16} />
            <span>{calendarView ? "List View" : "Calendar View"}</span>
          </Button>
        </div>
      </div>
    </div>
  );
});

InterviewManagementHeader.displayName = 'InterviewManagementHeader';

export default InterviewManagementHeader;